/* global modeoL10n */

import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

const dictionary = {
    fi: {
        messages: {
            required: function() {
                return modeoL10n.field_required;
            },
            email: function() {
                return modeoL10n.validation_email;
            },
            date_format: function(field, args) {
                if (args == 'DD.MM.YYYY') {
                    return modeoL10n.validation_date + ' ' + modeoL10n.validation_date_format;
                } else {
                    return modeoL10n.validation_date + ' ' + args
                }
            },
        },
    },
}

class FormValidations {
  constructor(Vue) {

      Vue.use(VeeValidate, {
        dictionary: dictionary,
        locale: 'fi',
      });

      Validator.extend('phone-fi', {
          getMessage: () => modeoL10n.validation_phone,
          validate: (value) => new Promise(resolve => {
              const phoneRegex = /^(\d{5,14})$/;
              let valid = false;
              if (value && value.match(phoneRegex)) {
                  valid = true;
              }
              resolve({
                  valid: valid,
              });
          }),
      });

      Validator.extend('businessid', {
          getMessage: () => modeoL10n.validation_businessid,
          validate: (value) => new Promise(resolve => {
              // http://tarkistusmerkit.teppovuori.fi/tarkmerk.htm#y-tunnus2

              const businessidRegex = /^[0-9]{7}-[0-9]{1}/;
              const oldBusinessidRegex = /^[0-9]{6}-[0-9]{1}/;
              const businessidMultipliers = [7, 9, 10, 5, 8, 4, 2];

              let companyID = value;
              let isValid = false;

              // old-style businessid
              if (companyID.match(oldBusinessidRegex)) {
                  companyID = '0' + companyID;
              }

              if (companyID.match(businessidRegex)) {
                  let numbers = companyID.substring(0, 7);
                  let checksum = companyID.substring(8, 9);

                  if (checksum == calculateChecksum(numbers)) {
                      isValid = true;
                  }
              }

              function calculateChecksum(numbers) {
                  let tempChecksum = 0;
                  let remainder = 0;

                  // count multiplied sum
                  for (let i in numbers) {
                      tempChecksum += numbers[i] * businessidMultipliers[i];
                  }

                  // divide with 11
                  remainder = tempChecksum % 11;

                  // if remainder is 0, checksum is 0
                  if (remainder == 0) {
                      return 0;
                  // no checksums of 1
                  } else if (remainder < 2 || remainder > 11) {
                      return false;
                  }

                  // should be valid, checksum is 11 - remainder
                  return 11 - remainder;
              }

              resolve({
                  valid: isValid,
              });
          }),
      });
  }
}

export default FormValidations;
